module.exports = __webpack_public_path__ + "static/media/Confirm.d7e3aee0.svg";